import type { NavigationGuard } from "vue-router";

import { useBackUrl } from "@/composables";
import { useUserStore } from "@/stores";

export function ordbogenAccountGuard(): NavigationGuard {
  return (to) => {
    const userStore = useUserStore();
    const backUrl = useBackUrl(to);

    if (!userStore.userData.credentials.ordbogenAccount) {
      return backUrl.value;
    }
  };
}
